import { hosts } from '~/config'

const module = {
  namespaced: true,
  registered: false,
  state: () => ({
    orderData: null,
  }),
  actions: {
    async applyCoupons({ commit }, coupons) {
      try {
        const { data } = await this.$http.post('/order/v1/order-form/payment', coupons)
        return data
      } catch (err) {
        console.log(err)
      }
    },
    async getOrderDetail({ commit }, orderId) {
      try {
        const { data } = await this.$http.get(`${hosts.hatsApi}/order/user/orders/${orderId}`)

        /**
         * kkday일때 vendorOrderForm 데이터가 들어오고 프론트 랜더를 위해 가공합니다.
         * 25.4Q 마이페이지 개편이 예정되어 있고 이때 API DTO 변경 예정이 되어 있어
         * 의도적으로 무식한 코드를 작성하였습니다.
         */
        data.seller?.forEach((seller) => {
          seller?.products?.forEach((product) => {
            if (!product?.vendorOrderForm?.targets) {
              return
            }

            product.vendorOrderForm.targets?.forEach((target) => {
              target.fields = product.vendorOrderForm.fields?.filter(
                (field) => target.id === field.targetId
              )
            })
          })
        })
        commit('setOrderDetail', data)
      } catch (err) {
        console.error(err)
        throw new Error(err)
      }
    },
    async getOrderCancelDetail({ commit }, orderId) {
      try {
        const { data } = await this.$http.get(`/order/v1/order/${orderId}/cancel-refund`)
        commit('setOrderCancelDetail', data)
      } catch (err) {
        console.log(err)
      }
    },
    async getCancelDetail({ commit }, orderId) {
      try {
        const { data } = await this.$http.get(`/order/v1/cancel/${orderId}`)
        commit('setCancelDetail', data)
      } catch (err) {
        console.log(err)
      }
    },
  },
  mutations: {
    setOrderDetail(state, orderData) {
      state.orderData = orderData
    },
    setOrderCancelDetail(state, orderCancelData) {
      state.orderCancelData = orderCancelData
    },
    setCancelDetail(state, cancelData) {
      state.cancelData = cancelData
    },
  },
}

export default module
